export const FILE_SIZE_LIMITS = {
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  MIN_FILE_SIZE: 1 // 1 byte
} as const;

export const PAGINATION_DEFAULTS = {
  PAGE_SIZE: 5,
  PUBLIC_PAGE_SIZE: 200,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100]
} as const;

export const MODAL_MODES = {
  CREATE: "create",
  EDIT: "edit"
} as const;

export const API_ENDPOINTS = {
  DOCUMENTS: "/api/v1/documents",
  DOCUMENTS_BY_AGENDA_ITEM: "/api/v1/documents/by-agenda-item",
  DOCUMENTS_DOWNLOAD_URL: "/api/v1/documents/download-url",
  PUBLIC_DOCUMENTS: "/api/v1/public/documents"
} as const;

export const TOAST_MESSAGES = {
  DOCUMENT_UPLOADED: {
    title: "Document uploaded",
    description: "The document has been successfully uploaded."
  },
  DOCUMENT_UPDATED: {
    title: "Document updated",
    description: "The document has been successfully updated."
  },
  DOCUMENT_DELETED: {
    title: "Document deleted",
    description: "The document has been successfully deleted."
  },
  UPLOAD_ERROR: {
    title: "Error",
    description: "Failed to upload document"
  },
  UPDATE_ERROR: {
    title: "Error",
    description: "Failed to update document"
  },
  DELETE_ERROR: {
    title: "Error",
    description: "Failed to delete document"
  },
  GENERIC_ERROR: {
    title: "Error",
    description: "An error occurred while processing your request"
  }
} as const;

export const ALLOWED_FILE_TYPES = {
  DOCUMENTS: ["pdf", "doc", "docx", "txt", "rtf", "odt"],
  IMAGES: ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"],
  SPREADSHEETS: ["xls", "xlsx", "csv", "ods"],
  PRESENTATIONS: ["ppt", "pptx", "odp"],
  ARCHIVES: ["zip", "rar", "7z", "tar", "gz"]
} as const;

// UI Text
export const UI_TEXT = {
  DRAG_DROP: {
    DEFAULT: "Drag and drop your file here",
    HOVER: "Drop your file here",
    BROWSE: "or click to browse files",
    BUTTON: "Browse Files"
  },
  FORM_LABELS: {
    FILENAME: "Filename",
    COMMENTS: "Internal Comments",
    PUBLIC_STATUS: "Status",
    PUBLIC_DESCRIPTION: "This document is publicly accessible",
    PRIVATE_DESCRIPTION: "This document is private"
  },
  PLACEHOLDERS: {
    FILENAME: "Enter filename",
    COMMENTS: "Add any internal notes or comments about this document",
    SELECT_FILE: "Please select a file to continue with document details"
  },
  MODAL_TITLES: {
    ADD: "Add New Document",
    EDIT: "Edit Document"
  },
  BUTTONS: {
    CANCEL: "Cancel",
    UPLOAD: "Upload File",
    UPDATE: "Update File",
    SAVING: "Saving..."
  }
} as const;
